
import React from 'react'
const LogoHeader = () => {
    return (
        <div
            style={{ backgroundColor: '#062E54', color: 'white', minHeight: 58 }}
            className="card-header text-center"  >
            <img src={require('../assets/images/Logo.png')} style={{ maxWidth: 200 }}></img>
        </div>
    )
}

export default LogoHeader
